/**
 * Created by mohit.chavda on 3/2/2017.
 */
import {Injectable,EventEmitter} from '@angular/core';
import {AppPendingApplications} from "../shared/AppPendingApplications";
import {Router} from "@angular/router";
import {ONLINE_APP_CONSTANTS} from "../common/constant/OnlineAppConstants";
import {Ethnicity} from "../shared/Ethnicity";
import {ListOfInfo} from "../shared/ListOfInfo";
import {State} from "../shared/State";
import {ApplicationService} from "./application.service";
import {Observable} from "rxjs/Rx";
import {ResponseResult} from "../shared/ResponseResult";
import {isBlank} from "@angular/forms/src/facade/lang";
import {ROUTE_CONSTANTS} from "../common/constant/RouteConstants";
import {Country} from "../shared/Country";

@Injectable()
export class LocalStorageService {

  constructor(private applicationService:ApplicationService) {  }

  // [[ =========== Used to Manage Session ================
  panelIndex = new EventEmitter<number>();

  getItem(key: string, defaultValue?: any): any {
    if (localStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key)) {
      return JSON.parse(localStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key));
    } else {
      return defaultValue;
    }
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(ONLINE_APP_CONSTANTS.APP_KEY + key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    localStorage.removeItem(ONLINE_APP_CONSTANTS.APP_KEY + key);
  }


  getSessionItem(key: string, defaultValue?: any): any {
    if (sessionStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key)) {
      return JSON.parse(sessionStorage.getItem(ONLINE_APP_CONSTANTS.APP_KEY + key));
    }else {
      return defaultValue;
    }
  }

  setSessionItem(key: string, value: any): void {
    sessionStorage.setItem(ONLINE_APP_CONSTANTS.APP_KEY + key, JSON.stringify(value));
  }

  removeSessionItem(key: string): void {
    sessionStorage.removeItem(ONLINE_APP_CONSTANTS.APP_KEY + key);
  }

  isUserLoggedIn() : boolean {
    let tokenflag : boolean = false;
    let token : string = this.getSessionItem('userId','');
    if(token != null && token != '' ){
      tokenflag=true;
    }
    return tokenflag;
  }
  // ============= 1. User ID =========
  getUserId() : number{
    return parseInt(this.getItem('userId',''));
  }
  setUserId(value: number){
    this.setItem('userId',value);
    this.setSessionItem('userId',value);
  }

  // ============= 2. Login User =========
  getLoginUser() : string{
    return this.getItem('loginUser','');
  }
  setLoginUser(value: string) {
    this.setItem('loginUser',value);
  }

  // ============= 3. Program Track =========
  // 'JD Program' & 'MLS Program'
  getProgramTrack() : number{
    return this.getItem('programTrack','');
  }
  setProgramTrack(value: number) {
    this.setItem('programTrack',value);
  }

  getProgram() : any{
    return this.getItem('program','');
  }
  setProgram(value: any) {
    this.setItem('program',value);
  }

  // ============= 4. Active Index =========
  // Active index has been used to set angular tabr's existing selection
  // it's start with 0 value
  getActiveIndex() : number
  {
    if(isNaN(parseInt(this.getItem('activeIndex',''))) == true)
      return 0;
    else
      return  parseInt(this.getItem('activeIndex',''));
  }
  setActiveIndex(value: number) {
    this.setItem('activeIndex',value);
    this.panelIndex.emit(value);
  }

  // ============= 5. Application ID =========
  getApplicationID() : number{
    var appId:number = this.getItem('applicationId','');
    if(isNaN(appId) == true || isBlank(appId) == true || appId <= 0)
    {
      appId = 0;
    }
    return appId;
    //this.getItem('applicationId','');
  }
  setApplicationID(value: number) {
    this.setItem(ONLINE_APP_CONSTANTS.LOCAL_STORAGE_APPLICATION_ID,value);
  }

  // ============= 6. Is Remember =========
  getIsRemember() : boolean{
    return this.getItem('isRemember','');
  }
  setIsRemember(value: boolean){
    this.setItem('isRemember',value);
  }
  // ============= 7. submit access=========
  getIsSubmit() : boolean{
    var isSubmit:boolean = this.getSessionItem('isSubmit',false);
    if(isSubmit == true)
      return true;
    else
      return false;
  }
  setIsSubmit(value: boolean){
    //console.log("this.setItem('isSubmit',value)");
    //console.log(this.setItem('isSubmit',value));
    this.setSessionItem('isSubmit',value);
    //this.setItem('isSubmit',value);
  }
  clearIsSubmit(){
    this.removeSessionItem('isSubmit');
    //this.removeItem('isSubmit');
  }
  // ============= 8. user email id =========
  getUserEmail() : string{
    return this.getItem('emailid','');
  }
  setUserEmail(value: string) {
    this.setItem('emailid',value);
  }
  clearUserEmail() {
    this.removeItem('emailid');
  }
  
  setApplicationIsNew(value: boolean) {
    this.setItem(ONLINE_APP_CONSTANTS.LOCAL_STORAGE_APPLICATION_IS_NEW,value);
  }

  removeApplicationIsNew() {
    this.removeItem(ONLINE_APP_CONSTANTS.LOCAL_STORAGE_APPLICATION_IS_NEW);
    //this.setItem(ONLINE_APP_CONSTANTS.LOCAL_STORAGE_APPLICATION_IS_NEW,value);
  }

  /* onContinueService(panelIndexValue: number) {
   console.log("ACTIVE INDEX 1" + panelIndexValue);
   this.setItem('activeIndex',panelIndexValue);
   console.log("ACTIVE INDEX 11" + this.getActiveIndex());
   this.panelIndex.emit(panelIndexValue);
   }

   onPreviousService(panelIndexValue: number) {
   console.log("ACTIVE INDEX" + panelIndexValue);
   this.setItem('activeIndex',panelIndexValue);
   console.log("ACTIVE INDEX.." + this.getActiveIndex());
   this.panelIndex.emit(panelIndexValue);
   }
   */

  removeLoginDetail(): void{
    this.removeItem('userId');
    this.removeSessionItem('userId');
    this.removeItem('loginUser');
    this.removeItem('programTrack');
    this.removeItem('activeIndex');
    this.removeItem('applicationId');
    this.removeItem('Authorization');
    this.removeItem('isRemember');
    this.removeItem('emailid');
    this.removeSessionItem('isSubmit');
    
    //this.removeItem('isSubmit');
  }
  // =========== Used to Manage Session ================ ]]

  // [[ =============== Used as Common Services =================



  //appPendingApplications:AppPendingApplications;
  commonEthnicityList:Ethnicity[] = [];
  commonListOfInfoList:ListOfInfo[] = [];
  commonStateList:State[] = [];
  commonCountryList:Country[] = [];

  getAppPendingApplications() : AppPendingApplications
  {
    return this.getItem('appPendingApplications','');
  }
  setAppPendingApplications(value: AppPendingApplications)
  {
    this.setItem('appPendingApplications',value);
  }

  setAppPageRoute(routeName:string,route : Router): void
  {
    if(routeName == ONLINE_APP_CONSTANTS.COM_APPLICATION_LIST)
    {
      route.navigate([ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION + ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION_LIST]);
    }
    else {

      var programTrack:number = this.getProgramTrack();

      if (programTrack != null && isNaN(programTrack) == false) {
        var routePath:string = "";

        switch (routeName) {
          case "contact":
            //Contact Info
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_CONTACT_INFO;
            else
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_CONTACT_INFO;

            this.setActiveIndex(0);
            break;
          case "demographics":
            //Personal Info
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_INFO;
            else
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_INFO;

            this.setActiveIndex(1);
            break;
          case "background":
            //Background Info
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_BACKGROUND_INFO;
            else
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_BACKGROUND_INFO;

            this.setActiveIndex(2);
            break;
          case "admission":
            //Admission Status
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_ADMISSION_STATUS;
            else
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_ADMISSION_STATUS;

            this.setActiveIndex(3);
            break;
          case "education":
            //Educational Background
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM)
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EDUCATIONAL_BACKGROUND;
            else
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_EDUCATIONAL_BACKGROUND;

            this.setActiveIndex(4);
            break;
          case "employment":
            //Employment Record
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EMPLOYMENT_RECORD;
              this.setActiveIndex(5);
            }
            else
              routePath = ""; // MLS does not have Employment Record page
            break;
          case "personalStatement":
          case "faithStatement":
          case "standardsSignature":
            //Personal Statement
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_STATEMENT;
              this.setActiveIndex(6);
            }
            else {
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_STATEMENT;
              this.setActiveIndex(5);
            }

            break;
          case "billing":
            //Payment Info
            if (programTrack == ONLINE_APP_CONSTANTS.JD_PROGRAM) {
              routePath = ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PAYMENT_INFO;
              this.setActiveIndex(7);
            }
            else
              routePath = ""; // MLS does not have Payment Info page
            break;
          default:
            routePath = "";
        }
        if(routePath != "") {
          route.navigate([ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION + routePath]);
          this.updateTabIndex();
        }
        else
        {
          console.log("Path is not found to route the page!!!");
        }

      }
    }
  }
  setActiveIndexFromURL(routeName:string): void
  {
    var activeIndex:number = 0;
    if(routeName == ONLINE_APP_CONSTANTS.COM_APPLICATION_LIST)
    {
      activeIndex = 0;
    }
    else {

      var programTrack:number = this.getProgramTrack();

      if (programTrack != null && isNaN(programTrack) == false) {

        routeName = routeName.replace(ONLINE_APP_CONSTANTS.ROUTE_PATH_APPLICATION ,"");

        switch (routeName) {
          //Contact Info
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_CONTACT_INFO:
            activeIndex = 0;
            break;
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_CONTACT_INFO:
            activeIndex = 0;
            break;
          //Personal Info
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_INFO:
            activeIndex = 1;
            break;
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_INFO:
            activeIndex = 1;
            break;

          //Background Info
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_BACKGROUND_INFO:
            activeIndex = 2;
            break;
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_BACKGROUND_INFO:
            activeIndex = 2;
            break;

          //Admission Status
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_ADMISSION_STATUS:
            activeIndex = 3;
            break;

          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_ADMISSION_STATUS:
            activeIndex = 3;
            break;

          //Educational Background
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EDUCATIONAL_BACKGROUND:
            activeIndex = 4;
            break;
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_EDUCATIONAL_BACKGROUND:
            activeIndex = 4;
            break;

          //Employment Record
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_EMPLOYMENT_RECORD:
            activeIndex = 5;
            break;

          //Personal Statement
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PERSONAL_STATEMENT:
            activeIndex = 6;
            break;
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_PERSONAL_STATEMENT:
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_FAITH_STATEMENT:
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_TIU_STANDARDS_SIGNATURE:
            activeIndex = 5;
            break;
          //Payment Info
          case ONLINE_APP_CONSTANTS.ROUTE_PATH_JD_PAYMENT_INFO:
            activeIndex = 7;
            break;

          default:
            activeIndex = 0;
        }
        this.setActiveIndex(activeIndex);
      }
    }
  }

  updateTabIndex(): void
  {
    console.log("INDEX:::"+this.getActiveIndex());
    if(isNaN(this.getActiveIndex()) == false) {
      this.panelIndex.emit(this.getActiveIndex());
    }
  }

  // ================= Get All Common List ============


  // Get all state information
  //RequestResult<ApplicationList>):Observable<ResponseResult<ApplicationList>>
  getCommonStateList():Observable<ResponseResult<State>>
  {
    return this.applicationService.getStateList().map(
      responseResult => {
        const applistAry = [];

        var stDefault:State = new State();
        stDefault.stateID = 0;
        stDefault.stateCode = ONLINE_APP_CONSTANTS.SELECT_STATE_DEFAULT;
        stDefault.stateName = ONLINE_APP_CONSTANTS.SELECT_STATE_DEFAULT;
        applistAry.push(stDefault);

        for (let key in   responseResult.valueObject) {

          var objState:State = new State();
          objState.stateID = responseResult.valueObject[key].stateID;
          objState.stateCode = responseResult.valueObject[key].stateCode;
          objState.stateName = responseResult.valueObject[key].stateName;
          applistAry.push(objState);
        }

        var stNotInList:State = new State();
        stNotInList.stateID = -1;
        stNotInList.stateCode = ONLINE_APP_CONSTANTS.SELECT_STATE_NOT_IN_LIST;
        stNotInList.stateName = ONLINE_APP_CONSTANTS.SELECT_STATE_NOT_IN_LIST;
        applistAry.push(stNotInList);

        this.commonStateList = applistAry;
        return responseResult;
      });
  }

  // Get all country information
  //RequestResult<ApplicationList>):Observable<ResponseResult<ApplicationList>>
  getCommonCountryList():Observable<ResponseResult<Country>>
  {
    return this.applicationService.getCountryList().map(
      responseResult => {
        const applistAry = [];

        var stDefault:Country = new Country();
        stDefault.countryID = 0;
        stDefault.countryCodeIso = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_DEFAULT;
        stDefault.countryCodeUn = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_DEFAULT;
        stDefault.countryName = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_DEFAULT;
        applistAry.push(stDefault);

        for (let key in   responseResult.valueObject) {
          var objCountry:Country = new Country();
          objCountry.countryID = responseResult.valueObject[key].countryID;
          objCountry.countryCodeIso = responseResult.valueObject[key].countryCodeIso;
          objCountry.countryCodeUn = responseResult.valueObject[key].countryCodeUn;
          objCountry.countryName = responseResult.valueObject[key].countryName;
          applistAry.push(objCountry);
        }

        var stNotInList:Country = new Country();
        stNotInList.countryID = -1;
        stNotInList.countryCodeIso = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_NOT_IN_LIST;
        stNotInList.countryCodeUn = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_NOT_IN_LIST;
        stNotInList.countryName = ONLINE_APP_CONSTANTS.SELECT_COUNTRY_NOT_IN_LIST;
        applistAry.push(stNotInList);

        this.commonCountryList = applistAry;
        return responseResult;
      });
  }
  // Get All Ethnicity List
  getCommonEthnicityList():Observable<ResponseResult<Ethnicity>>
  {
    return this.applicationService.getEthnicityList().map(
      responseResult => {
        console.log('Ethinicity');
        console.log(responseResult);
        const applistAry = [];
        for (let key in   responseResult.valueObject) {

          var objEthnicity:Ethnicity = new Ethnicity();
          objEthnicity.ethnicityID = responseResult.valueObject[key].ethnicityID;
          objEthnicity.ethnicity = responseResult.valueObject[key].ethnicity;
          objEthnicity.allowCustomInput = responseResult.valueObject[key].allowCustomInput;
          objEthnicity.sortOrder = responseResult.valueObject[key].sortOrder;
          applistAry.push(objEthnicity);
        }
        this.commonEthnicityList = applistAry;
        return responseResult;
      });
  }

  // Get all List of Information
  getCommonListOfInfoList():Observable<ResponseResult<ListOfInfo>>
  {
    return this.applicationService.getListOfInfoList().map(

      responseResult => {
        console.log('List Of Info');
        console.log(responseResult);
        const applistAry = [];
        for (let key in   responseResult.valueObject) {

          var objListOfInfo:ListOfInfo = new ListOfInfo();
          objListOfInfo.infoSourceID = responseResult.valueObject[key].infoSourceID;
          objListOfInfo.infoSource = responseResult.valueObject[key].infoSource;
          objListOfInfo.allowCustomInput = responseResult.valueObject[key].allowCustomInput;
          objListOfInfo.sortOrder = responseResult.valueObject[key].sortOrder;
          applistAry.push(objListOfInfo);
        }
        this.commonListOfInfoList = applistAry;
        return responseResult;
      });
  }


  // =============== Used as Common Services ================= ]]

}



// WEBPACK FOOTER //
// ./src/app/services/LocalStorage.service.ts